module.exports = __webpack_public_path__ + "img/TOP_LOGO.1550bb2.png";